<template>
  <div class="dynamic-attr-text dynamic-attr-file">
    <div
      :class="'dynamic-attr-text-title '+ (attrObj.mustFlag=='1'?'is-item-required':'')"
      :style="{width: $pScreen.textW,fontSize:$pScreen.titleS}"
    >
      <span>{{attrObj.title}}</span>
    </div>
      <!-- <Button type="ghost" :class="{disabledBtn: attrObj.disabled}" :disabled="attrObj.disabled">{{$t('选择文件')}}</Button> -->
      <div v-if="attrObj.desc" class="fileStyle">
          <!-- {{attrObj.desc}} -->
          <div style="width: 120px;">
              <img :src="attrObj.desc" style="width: 100%;" />
          </div>
      </div>
  </div>
</template>




<script>
export default {
  props: {
    attrObj: Object
  },
  data() {
    return {
      
    };
  },
  created() {
    
  },
  //初始化后调用
  mounted: function() {
    
  },
  methods: {
   
  }
};
</script>
<style>
  .disabledBtn{
    background: #f7f7f7 !important;
    color: #ccc !important;
  }
  .fileStyle {
      font-size: 12px;
      padding: 0 15px 15px 15px;
  }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/selectedFile.vue